<script>
  import Portal from "svelte-portal"

  import Alert from "@percs/client/internal/PercsAlert.svelte"
  import PostHog from "$lib/components/post-hog.svelte"
  import alerts from "$lib/stores/snackbar"
  import "../app.css"
</script>

<svelte:head>
  <!-- Material Icons -->
  <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/icon?family=Material+Icons"
  />
  <!-- Work Sans -->
  <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@500&display=swap"
  />
  <!-- SMUI Styles -->
  <link rel="stylesheet" href="/smui.css" />
  <!-- Checksum AI -->
  <!-- <script src="https://cdn.checksum.ai/checksum-sdk-min-0.1.js" on:load={initialiseChecksum}></script> -->
</svelte:head>

<PostHog />
<slot />
<div data-portal-location="drawers"></div>
<div data-portal-location="modals"></div>
<div data-portal-location="popovers"></div>
<div data-portal-location="alerts"></div>
<Portal target="[data-portal-location=alerts]">
  <div class="fixed bottom-24 space-y-4 flex flex-col items-center right-0 min-w-[300px] -translate-x-4 z-50">
    {#each $alerts as alert (alert.id)}
      <Alert
        type={alert.status}
        message={alert.message}
        description={alert.description ?? ""}
        isHtmlMessage={alert.isHtmlMessage}
        on:dismiss={() => alerts.dismiss(alert)}
      />
    {/each}
  </div>
</Portal>
